import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHelmet = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 64 64",
	fillOpacity: 0,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M37.3338 14.8271C42.336 16.0296 46.7887 18.8791 49.976 22.9176C53.1633 26.9561 54.9 31.9491 54.9071 37.0938V42.1871H9.09377V37.0938C9.08665 31.9454 10.8181 26.9454 14.0077 22.904C17.1973 18.8626 21.658 16.0166 26.6671 14.8271",
			stroke: "currentColor",
			strokeWidth: 5.09333,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.9067 42.1865H9.09333C6.28036 42.1865 4 44.4669 4 47.2799C4 50.0928 6.28036 52.3732 9.09333 52.3732H54.9067C57.7196 52.3732 60 50.0928 60 47.2799C60 44.4669 57.7196 42.1865 54.9067 42.1865Z",
			stroke: "currentColor",
			strokeWidth: 5.09333,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.6264 42.187H24.373L26.9064 11.627H37.093L39.6264 42.187Z",
			stroke: "currentColor",
			strokeWidth: 5.09333,
			strokeMiterlimit: 10
		})
	]
});
export default SvgHelmet;
